module.exports = __webpack_public_path__ + "img/offshore.96114500.png";